import { render, staticRenderFns } from "./receivers-select.vue?vue&type=template&id=fd5acee2&scoped=true&"
import script from "./receivers-select.js?vue&type=script&lang=js&"
export * from "./receivers-select.js?vue&type=script&lang=js&"
import style0 from "./receivers-select-vuetify.css?vue&type=style&index=0&lang=css&"
import style1 from "./receivers-select.css?vue&type=style&index=1&id=fd5acee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5acee2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VDivider,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle})
